import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useFinishImportOpportunitiesMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportOpportunitiesJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			systemJobId,
			options,
			impersonationContext,
		}: {
			systemJobId: string;
			options: Api.IImportOpportunitiesOptions;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IImportOpportunitiesJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `board/items/importFromFile/${systemJobId}`,
				}),
				'POST',
				options
			);
		},
		onError,
		onSuccess,
	});
};
